"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function reconnectingSocket(createSocket) {
    let reconnectDelay = 500;
    let listeners = [['close', queueReconnect]];
    let timeout;
    let currentSocket = newSocket();
    function newSocket() {
        const _a = createSocket(), { addEventListener, removeEventListener } = _a, socket = __rest(_a, ["addEventListener", "removeEventListener"]);
        for (const args of listeners) {
            addEventListener(...args);
        }
        return Object.assign(Object.assign({}, socket), { addEventListener(...args) {
                listeners = [...listeners, args];
                addEventListener(...args);
            },
            removeEventListener(...args) {
                listeners = listeners.filter(listener => !(args[0] === listener[0] && args[1] === listener[1]));
                removeEventListener(...args);
            },
            close(...args) {
                removeEventListener('close', queueReconnect);
                clearTimeout(timeout);
                socket.close(...args);
            } });
    }
    function queueReconnect() {
        clearTimeout(timeout);
        timeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            try {
                if (process.env.NODE_ENV !== 'test') {
                    console.info('Attempting to connect to socket.');
                }
                currentSocket = newSocket();
            }
            catch (e) {
                currentSocket.close();
                queueReconnect();
            }
        }), reconnectDelay);
        if (process.env.NODE_ENV !== 'test') {
            console.error(`Socket disconnected, attempting to reconnect in ${reconnectDelay / 1000}s`);
        }
        reconnectDelay = Math.min(reconnectDelay * 2, 30000);
    }
    return new Proxy(currentSocket, {
        get: (_target, prop) => {
            if (typeof currentSocket[prop] === 'function') {
                return (...args) => {
                    return currentSocket[prop](...args);
                };
            }
            else {
                return currentSocket[prop];
            }
        },
    });
}
exports.default = reconnectingSocket;
//# sourceMappingURL=reconnectingSocket.js.map